<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();
// Popup Hops
const showHops = ref(false);

const toggleHops = () => {
    showHops.value = !showHops.value;
};

const closeHops = () => {
    showHops.value = false;
};

// Lấy site_url từ window.commonData của Laravel
const site_url = window?.commonData?.settings?.site_url || "";

// State từ Vuex
const isAuthenticated = computed(() => store.state.user.isAuthenticated);
const homelogo_url = computed(() => window.commonData.settings.home_logo);
const site_title = computed(() => window.commonData.settings.site_title);
const user = computed(() => store.state.user.user);
const dashboard_url = computed(() => {
    const role = user.value?.role;

    if (role === 1) return "/admin/dashboard";
    if (role === 2) return "/manager/dashboard";
    if (role === 3) return "/user/dashboard";

    return "/";
});

// Logout
const handleLogout = async () => {
    await store.dispatch("user/logoutUser");
    router.push("/");
};

// Đi tới trang login
const goLogin = () => {
    window.location.href = site_url + "/login";
};
</script>

<template>
  <header class="header">
    <div class="logo"> <router-link class="navbar-brand" to="/"  @click="scrollToTop">
                <img :src="homelogo_url + '?v=' + v" :title="site_title" style="border-radius: 10px;width: 90px;" />
            </router-link></div>

    <div class="search-bar">
      <input type="text" placeholder="Find game or genre" />
    </div>

    <div class="top-right">
      <!-- Nếu chưa đăng nhập -->
      <template v-if="!isAuthenticated">
        <div class="login-btn" @click="goLogin">Log In</div>
      </template>

      <!-- Nếu đã đăng nhập -->
      <template v-else>
        <div class="coin-box" @click="toggleHops">{{ user?.coins ?? 0 }} 🪙</div>
        <div class="notif-box">🔔</div>

        <div class="user-box dropdown">
          <span>{{ user?.username }}</span>
          <div class="dropdown-content">
				<div @click="router.push('/profile')">
					<i class="bi bi-person-circle me-2"></i> Profile
				</div>

				<div> <a :href="dashboard_url" style="color: #fff; text-decoration: none;">
					<i class="bi bi-speedometer2 me-2"></i> Dashboard
					</a>
				</div>

				<div @click="handleLogout">
					<i class="bi bi-box-arrow-right me-2"></i> Logout
				</div>
			</div>
        </div>
      </template>
    </div>
	<!-- HOPS POPUP -->
	<div v-if="showHops" class="overlay" @click="closeHops"></div>

	<div v-if="showHops" class="hops-popup">
	  <div class="arrow-up"></div>

	  <div class="hops-header">
		You have <strong>{{ user?.coins ?? 0 }}</strong> hops
		<span class="close-btn" @click="closeHops">✖</span>
	  </div>

	  <div class="hops-box">
		🟦 Hops are bonuses on the service.<br />
		They can be received in promotions.
		<div class="link">Games that take hops ></div>
	  </div>

	  <div class="promo-title">Promotions with bonus hops:</div>

	  <div class="promo-card green">
		<div class="icon">📦</div>
		<div class="text">Bonuses for any set of hops</div>
	  </div>

	  <div class="promo-card">
		<div class="icon">🎁</div>
		<div class="text">New promotions are coming soon</div>
	  </div>

	  <button class="buy-btn">Buy Hops</button>
	</div>
  </header>
</template>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #2a2a2a;
  position: sticky;
  top: 0;
  z-index: 10;
}
.logo {
  font-size: 26px;
  font-weight: 700;
  color: #59ff9e;
}
.search-bar input {
  width: 50%;
  padding: 10px 15px;
  background: #3a3a3a;
  border: none;
  border-radius: 14px;
  color: #ddd;
  font-size: 15px;
}

.top-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.coin-box,
.notif-box,
.login-btn {
  background: #3a3a3a;
  padding: 8px 14px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
}

.login-btn {
  background: #59ff9e;
  color: #000;
  font-weight: 600;
}

/* User dropdown */
.user-box {
  position: relative;
  background: #3a3a3a;
  padding: 8px 14px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-content {
  position: absolute;
  margin-top: 6px;
  right: 0;
  background: #3a3a3a;
  padding: 10px 0;
  border-radius: 10px;
  min-width: 140px;
  display: none;
  flex-direction: column;
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
}

.dropdown-content div {
  padding: 10px 14px;
  cursor: pointer;
}

.dropdown-content div:hover {
  background: #4a4a4a;
}

.user-box:hover .dropdown-content {
  display: flex;
}

/* Overlay */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 20;
}

/* Popup Wrap */
.hops-popup {
  position: absolute;
  right: 20px;
  top: 65px;
  width: 330px;
  background: #2e2e2e;
  border-radius: 16px;
  padding: 18px;
  z-index: 21;
  box-shadow: 0 8px 25px rgba(0,0,0,0.4);
  animation: fadeIn 0.15s ease-out;
}

/* Mũi tên */
.arrow-up {
  position: absolute;
  top: -12px;
  right: 32px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 12px solid #2e2e2e;
}

.hops-header {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  margin-bottom: 15px;
}

.close-btn {
  cursor: pointer;
  opacity: 0.7;
}
.close-btn:hover {
  opacity: 1;
}

/* Info box */
.hops-box {
  background: #3b3b3b;
  padding: 14px;
  border-radius: 14px;
  line-height: 1.4em;
  margin-bottom: 18px;
}

.link {
  margin-top: 6px;
  color: #59ff9e;
  cursor: pointer;
  font-size: 14px;
}

.promo-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}

.promo-card {
  display: flex;
  align-items: center;
  background: #3b3b3b;
  padding: 10px 12px;
  border-radius: 14px;
  margin-bottom: 12px;
}

.promo-card .icon {
  font-size: 20px;
  margin-right: 10px;
}

.promo-card.green {
  background: #59ff9e;
  color: #000;
}

.buy-btn {
  width: 100%;
  background: #59ff9e;
  padding: 12px 0;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 10px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

</style>
